import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconComponent } from './icon.component';

/**
 * Module providing icon display functionality.
 *
 * @remarks
 * This module exports the {@link IconComponent} for displaying scalable icons from the Backbase
 * icon library. Import this module to use the `bb-icon-ui` component in your templates.
 *
 * @example
 *
 * ```typescript
 * import { IconModule } from '@backbase/ui-ang/icon';
 *
 * @NgModule({
 *   imports: [IconModule]
 * })
 * export class FeatureModule {}
 * ```
 */
@NgModule({
  imports: [NgClass],
  declarations: [IconComponent],
  exports: [IconComponent],
})
export class IconModule {}
